import { useState, useContext } from 'react'
import { API_URL, doApiGet } from '../../services/apiService'
import { transformToRDTNode } from './Stage1_Transform'
import { FamilyContext } from '../../Context/FamilyHeadContext'

export function useFamilyTree() {
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [treeData, setTreeData] = useState(null)
  const [zoom, setZoom] = useState(1)
  const [expandedNodes, setExpandedNodes] = useState(new Set())
  const { isMainSite } = useContext(FamilyContext)

  const initializeTree = async (gedId) => {
    setLoading(true)
    setError(null)

    try {
      const data = await doApiGet(
          `${API_URL}/people/family-tree/${gedId}/${
              isMainSite === 'bazach' ? 'bazach' : 'huminer'
          }`,
      )
      console.log("dataMain",data)
      setTreeData(transformToRDTNode(data))
      setExpandedNodes(new Set([gedId]))
    } catch (err) {
      setError('אירעה שגיאה בטעינת הנתונים')
      console.error(err)
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    error,
    treeData,
    zoom,
    setZoom,
    setTreeData,
    initializeTree,
    expandedNodes,
    setExpandedNodes,
  }
}